import { useState ,useEffect} from "react";
import PairList from "./PairList";
import '../styles/index.css'
const Files = () => {
    return ( 
        <h1>Comming Soon</h1>
    );
}
 
export default Files; 